export default __webpack_public_path__ + "static/media/hamburger-icon.217d35c4.png";